<template>
  <div style="height: 100%; position: relative" class="mapDiv">
    <div id="map" class="map"></div>
    <c-name
      v-if="JSON.stringify(param) !== '{}'"
      :param="param"
      class="detail"
    ></c-name>
  </div>
</template>

<script>
import L from "leaflet";
// import "leaflet/dist/leaflet.css";
// import cDetail from '../util/detail'
import changeMap from "../util/changeMap";
import cName from "../util/name";
import { findDataProjectByDataProjectTypeIdNYDP } from "@/api/base";
import { mapGetters } from "vuex";
export default {
  components: {
    cName
  },
  data() {
    return {
      map: null,
      hoverList: [],
      ncIndex: null,
      ncCode: "",
      param: {},
      poisiton: {}
    };
  },
  computed: {
    ...mapGetters(["rightComponentBak"])
  },
  mounted() {
    this.initMap();
  },
  methods: {
    initMap() {
      var url = require("images/map/dt1.png");
      var map = L.map("map", {
        minZoom: 17,
        maxZoom: 20,
        center: [-0.00200653076171875, 0.0021896362304687],
        zoom: 17,
        crs: L.CRS.Simple,
        attributionControl: false
      });
      this.map = map; //data上需要挂载
      window.map = map;
      var northEast = this.map.unproject([2271, 0], this.map.getMaxZoom() - 1); //东北 右上角northEast
      var southWest = this.map.unproject([0, 2406], this.map.getMaxZoom() - 1); //西南 左下角southWest
      var bounds = new L.LatLngBounds(southWest, northEast);
      L.imageOverlay(url, bounds, { interactive: false }).addTo(map);
      // map.setMaxBounds(bounds);//设置了地图和图片一样大小，取消之后，自定义地图可以随意拖拽
      map.on("click", e => {
        console.log(e.latlng);
      });
      map.on("move", () => {
        this.param = {};
      });
      this.areaLoad();
      this.qutzLoad();
    },
    //区域数据加载
    areaLoad() {
      let areaArr = this.$config.areaArr;
      this.mianArr = [];
      for (let i = 0, len = areaArr.length; i < len; i++) {
        L.polygon(areaArr[i].rings, {
          color: areaArr[i].color,
          fillColor: areaArr[i].color,
          fillOpacity: 0.5,
          attributes: areaArr[i]
        }).addTo(this.map);
      }
    },
    //获取园区总投资数据
    qutzLoad() {
      findDataProjectByDataProjectTypeIdNYDP({ dataProjectTypeId: "" }).then(
        res => {
          let lists = res.data;
          let sj = [];
          let sj1 = 0;
          let sj2 = 0;
          let sj3 = 0;
          let sj4 = 0;
          let sj5 = 0;
          let sj6 = 0;
          let sj7 = 0;
          lists.map(it => {
            let sbjes = it.dataProjectTypeId;
            if (sbjes != null) {
              if (sbjes.code == "cyrh") {
                sj1 = sj1 + 1;
              } else if (sbjes.code == "ddlz") {
                sj2 = sj2 + 1;
              } else if (sbjes.code == "nyss") {
                sj3 = sj3 + 1;
              } else if (sbjes.code == "kjyxxzc") {
                sj4 = sj4 + 1;
              } else if (sbjes.code == "ggqypp") {
                sj5 = sj5 + 1;
              } else if (sbjes.code == "dktx") {
                sj6 = sj6 + 1;
              } else if (sbjes.code == "qt") {
                sj7 = sj7 + 1;
              } else {
                sj7 = sj7 + 1;
              }
            }
          });
          sj = [
            {
              tc_name: "全部(" + res.data.length + ")",
              tc_pic: "icon_all.png"
            },
            {
              tc_name: "产业融合(" + sj1 + ")",
              tc_pic: "icon_cy.png"
            },
            {
              tc_name: "土地流转(" + sj2 + ")",
              tc_pic: "icon_td.png"
            },
            {
              tc_name: "农业设施(" + sj3 + ")",
              tc_pic: "icon_nyss.png"
            },
            {
              tc_name: "科技与信息支撑(" + sj4 + ")",
              tc_pic: "icon_kj.png"
            },
            {
              tc_name: "公共区域品牌(" + sj5 + ")",
              tc_pic: "icon_ggqy.png"
            },
            {
              tc_name: "贷款贴息(" + sj6 + ")",
              tc_pic: "icon_dk.png"
            },
            {
              tc_name: "其它(" + sj7 + ")",
              tc_pic: "icon_qt.png"
            }
          ];
          this.$store.dispatch("map/setBottomList", sj);
          res.data.map(it => {
            if (it.latitude) {
              let aPoint = new changeMap(it.latitude, it.longitude);
              console.log("apoint", aPoint.lat, aPoint.lng);
              it.lat = aPoint.lat;
              it.lng = aPoint.lng;
              //   it.lat = it.latitude;
              //   it.lng = it.longitude;
              let iconImg;
              let sbje = it.dataProjectTypeId;
              if (sbje != null) {
                if (sbje.code == "cyrh") {
                  iconImg = require("images/map/icon_cyrh_c.png");
                } else if (sbje.code == "ddlz") {
                  iconImg = require("images/map/icon_tdlz_c.png");
                } else if (sbje.code == "nyss") {
                  iconImg = require("images/map/icon_nyss_c.png");
                } else if (sbje.code == "kjyxxzc") {
                  iconImg = require("images/map/icon_kjxx_c.png");
                } else if (sbje.code == "ggqypp") {
                  iconImg = require("images/map/icon_ggqy_c.png");
                } else if (sbje.code == "dktx") {
                  iconImg = require("images/map/icon_dktx_c.png");
                } else if (sbje.code == "qt") {
                  iconImg = require("images/map/icon_qt_c.png");
                }
                let pointIcon = L.icon({
                  iconUrl: iconImg,
                  iconSize: [30, 30],
                  iconAnchor: [10, 40],
                  popupAnchor: [0, 0]
                });
                let ssztLayer = L.marker([it.lat, it.lng], {
                  icon: pointIcon,
                  attributes: it
                }).addTo(this.map);
                ssztLayer.on("click", e => {
                  // 缓存rightcomponent
                  sessionStorage.setItem(
                    "rightComponent",
                    this.rightComponentBak
                  );
                  setTimeout(() => {
                    this.$store.dispatch(
                      "drawer/setGraphic",
                      e.sourceTarget.options.attributes
                    );
                    this.$store.dispatch(
                      "drawer/setRightComponent",
                      "yqztzDrawer"
                    );
                  }, 10);
                });
                ssztLayer.on("mouseover", it => {
                  this.param = {
                    x: it.containerPoint.x,
                    y: it.containerPoint.y,
                    name: it.sourceTarget.options.attributes.name
                  };
                  this.ncCode = it.target.options.attributes.code;
                });
                ssztLayer.on("mouseout", () => {
                  this.param = {};
                });
              }
            }
          });
        }
      );
    }
  },
  destroyed() {
    clearInterval(this.timer);
  }
};
</script>

<style lang="stylus" scoped>
.map
  background none !important
  width 100%
  height calc(100% + 105px)
  z-index 9
  // >>>.leaflet-tile-pane
  // display none
  >>>.leaflet-bar
    display none
  >>>.leaflet-bottom
    display none
  .ncDetail
    position absolute
@media (max-width 1280px)
  .mapDiv
    transform scale(0.75)
</style>
